"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesNoScriptExist = exports.doesScriptExist = exports.doesScriptSrcUrlExist = void 0;

var _find2 = _interopRequireDefault(require("lodash/find"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var doesScriptExist = function doesScriptExist(script) {
  var tags = document.getElementsByTagName('script');
  return (0, _find2["default"])(tags, function (src) {
    return src.innerHTML && script.innerHTML && src.innerHTML === script.innerHTML;
  });
};

exports.doesScriptExist = doesScriptExist;

var doesNoScriptExist = function doesNoScriptExist(noscript) {
  var tags = document.getElementsByTagName('noscript');
  return (0, _find2["default"])(tags, function (src) {
    return src.innerHTML === noscript.innerHTML;
  });
};

exports.doesNoScriptExist = doesNoScriptExist;

var doesScriptSrcUrlExist = function doesScriptSrcUrlExist(script) {
  var tags = document.getElementsByTagName('script');
  return (0, _find2["default"])(tags, function (src) {
    return script.src === src.src;
  });
};

exports.doesScriptSrcUrlExist = doesScriptSrcUrlExist;